<template>
  <a
    v-if="isLogin"
    :href="`${consoleDomain}/${locale}`"
    target="_self"
    rel="noopener noreferrer"
    title="WISE-Console"
    class="w-[60px] text-sm font-bold text-blue-400 hover:text-blue-500 hover:underline"
  >
    Console
  </a>
</template>

<script setup lang="ts">
  const { locale } = useI18n();
  const { consoleDomain } = useWebsite();

  const profileStore = useProfileStore();
  const { isLogin } = storeToRefs(profileStore);
</script>
